<template>
  <div class="animated fadeIn list-of-advance">
    <b-card>
      <div slot="header">List of Cash Advance Request 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <!-- <b-button variant="primary mr-1" @click="payment()">Payment History</b-button> -->
          <b-button variant="primary mr-1" @click="approvalConfirm()" v-if="(use_wfservice==1)"><i class="fa fa-pa per-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" style="width:23% !important;"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" style="width:23% !important;"></b-form-input>
                <b-input-group-prepend><span class="ml-2 pt-2">Outstand &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Request Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Pay To &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.dibayarke" placeholder="Pay to"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      

              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Cash Advance Acc.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                      </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Acc. Name&nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
              <b-row>
                <b-col lg="12" class="text-right" >
                <b-input-group>
                    <b-input-group-prepend>
                      <label>Advance Group</label>
                    </b-input-group-prepend>
                    <b-form-select
                      v-model="tblData.jenisAdv"
                      :plain="true"
                      :options="postGroups"
                    ></b-form-select>
                    <b-input-group-append>
                      <label class="pt-2 ml-2 mr-2">Outstand Settlement</label>
                    </b-input-group-append>
                    <b-form-select
                      v-model="tblData.jenisSettlOS"
                      :plain="true"
                      :options="dataList.YesNoAll"
                    ></b-form-select>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group>
                    
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>

      <b-table
        class="mb-0 "
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-advanKey="data.item.advanKey"
            :checked="ischeckedjurnal(data.item.advanKey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="((data.item.posting==1) || ((data.item.send2wf==1) && (data.item.isreviewed==0)))" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrintpb(data.item)" href="#" :disabled="(data.item.balandue!=0)" style="padding:0 !important;">Perintah Bayar</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item> -->
          <b-dropdown-item @click="rowPrint(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print</b-dropdown-item>
          <b-dropdown-item @click="refreshSaldo(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Refresh Saldo Adv.</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>
        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("DD MMM YYYY") }}
        </template>
       <template v-slot:cell(jumlah)="data">
          {{data.item.jumlah|numFormat}}
        </template>
        <template v-slot:cell(nilaiByr)="data">
          {{data.item.nilaiByr|numFormat}}
        </template>
        <template v-slot:cell(advSettlAmt)="data">
          <span v-if="(data.item.advSettlAmt)">{{data.item.advSettlAmt|numFormat}}</span>
        </template>
        <template v-slot:cell(iDocsURL)="data">
          <b-link @click="open_iDocs(data.item)" v-if="(data.item.iDocsURL)">iDoc</b-link>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>


      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label class="text-right">Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-form-row>
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                  <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                  <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-form-row>                      
          <b-form-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col>
              <!-- <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label class="text-right">Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col> -->
          </b-form-row>                      

          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.keterangan"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
              <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1"  @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal v-model="actionHistoryShow" header-bg-variant="primary"  title="Action History" size="lg" :centered="true" ok-only>
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label class="text-right">Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-form-row>
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                  <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                  <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-form-row>                      
          <b-form-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col>
              <!-- <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label class="text-right">Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col> -->
          </b-form-row>                      

          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.keterangan"  readonly></b-form-input>
          </b-input-group>
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="120px">Action Date</th>
                    <th >Comment</th>
                    <th width="100px">Action By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in actionHistory" :key="row.reqactionkey">
                    <td> {{row.actiondate | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>{{row.actiondtl}}</td>
                    <td>{{row.actionby}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
      </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-advance {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
  .input-group {
      .input-group-prepend {
          label {
              width: 110px !important;
          }
      }
  }  
 
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import advance from "../../apis/advance";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      // showPostingConfirm: false,
      // showUnpostConfirm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,        
        tgl2:moment().format('YYYY-MM-DD'),        
        sortBy: 'tglRequ',
        sortDesc: false,
        DimCol:'Dim1',outstand:'',jenisSettlOS:'',jenisAdv:''
      },
      postGroups:[],
      selected:[],
      dataList: {
        YesNoAll: dropdown.YesNoAll
      },
      actionHistoryShow:false,
      actionHistory:[],   
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      use_wfservice:this.$store.state.user.use_wfservice,
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:50px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "namaAdvan",
            label: "Advance Group",
            sortable: true
          },
          {
            key: "tglRequ",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Request By",
            sortable: true
          },
          {
            key: "dibayarke",
            label: "Paid to",
            sortable: true
          },
          {
            key: "iDocsURL",
            label: "",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Request Amount",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nomorbank",
            label: "Trx.Bank/Cash#",
            sortable: true
          },
          {
            key: "nilaiByr",
            label: "Paid",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nomorSttl",
            label: "Settlement#",
            sortable: true
          },
          {
            key: "advSettlAmt",
            label: "Settlement Amt.",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
    created: async function () {
        this.postGroups = await advance.advancegroup();
        this.postGroups.unshift({value:'',text:'All'});

    },
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const advanKey = item.target.attributes["data-advanKey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === advanKey);
        if (!(findjv)){
          this.selected.push(advanKey);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === advanKey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.advreqlist) {
            this.tblData[key] = filter.advreqlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.advreqlist.tgl1 || '';
          this.tblData.tgl2=filter.advreqlist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.advreqlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

        try {
            const list = await advance.list(this.tblData);      
            this.items = list;
            this.isLoading=false;
          return list;
        } catch (error) {
            this.isLoading=false;
          console.log(error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
        }

    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeaccc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.dibayarke=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'dibayarke', 'kodeacc', 'namaacc','isProject', 'crewkey', 'crewname'];
      let filtered = false;
      const advreqlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              advreqlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          advreqlist.page=this.tblData.page;
          advreqlist.limit=this.tblData.limit;
          advreqlist.sortBy=this.tblData.sortBy;
          advreqlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.advreqlist=advreqlist;
          this.$store.commit("filter", filter);
      }
    },     
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintpb(record) {
      this.rowClicked(record);
        this.printpb();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    refreshSaldo: async function(record) {
        this.rowClicked(record);
        this.isLoading=true;
        await advance.refreshSaldo(this.model);
        this.refresh();
        this.isLoading=false;
    },
    add(){
      this.saveFilter();
      router.push({name :"advance.requestfrm"});
    },
    edit: function() {
        if (this.model.advanKey) {
        this.saveFilter();
          router.push({name :'advance.requestfrm', params: { advanKey: this.model.advanKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.advanKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
        this.isLoading=true;
        await advance.remove(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.advanKey==this.model.advanKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
    },
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    // posting: async function () {
    //     if (this.model.advanKey) {
    //         if ((this.model.send2wf || 0) == 0) {
    //             this.showPostingConfirm = true;
    //         }
    //         if (this.model.send2wf == 1) {
    //             this.showUnpostConfirm = true;
    //         }
    //     } else {
    //         toastr.warn('Please select a row that want to be Posted!');
    //     }
    // }, 
    // postingData: async function(){
    //     this.isLoading=true;
    //     try {
    //         await advance.submit(this.model);
    //         this.model.send2wf=1;
    //         // this.printjv();
    //         this.isLoading=false;
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    // },  
    // unpostData: async function(){
    //     this.isLoading=true;
    //     try {
    //         await advance.submitCancel(this.model);
    //         this.model.send2wf=0;
    //         this.isLoading=false;
    //     } catch (error) {
    //         this.isLoading=false;
    //         if (error.message) {
    //             toastr.error(error.message,'ERROR MESSAGE',10000);
    //         } else {
    //             toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //         }
    //     }
    // },  
    payment: function() {
      if (this.model.advanKey) {
          this.saveFilter();
          router.push({name :'advance.paymview', params: { advanKey: this.model.advanKey}});
          this.showUploadFrm=true;
        } else {
            toastr.warn('Please select a row that want to be viewed!');
        }
    },    
    print: async function()
    {
      if (this.model.advanKey) {
          try {
                this.showReport=true;
              this.reportUrl= await advance.print(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpb: async function()
    {
      if (this.model.advanKey) {
          try {
                this.showReport=true;
              this.reportUrl= await advance.printpb(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpbselected: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.reportUrl= await advance.printpbmultiple(this.selected);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
            console.log(error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
          this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            const response = await advance.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/advance/home");
    },    
    async open_iDocs(doc) {
      this.$open_iDocs(doc, (state) => this.isLoading = state);
    },
  }
};
</script>
